export class DeviceUtils {

  public static isTouch(): boolean {
    return `ontouchstart` in window;
  }

  public static isAndroid(): boolean {
    return /android/i.test(navigator.userAgent);
  }

  public static isIos(): boolean {
    return /iPad|iPhone|iPod/i.test(navigator.userAgent)
      || ((navigator.platform === 'MacIntel' || /Mac OS/i.test(navigator.userAgent)) && navigator.maxTouchPoints > 1);
  }

  public static isMobile(): boolean {
    return (DeviceUtils.isIos() || DeviceUtils.isAndroid()) && DeviceUtils.isTouch();
  }
}
